import {
  GetAnualidadProyecto,
  GetAnualidadProyectosOptions,
  State as ComisionAnualidadState
} from "../../../reducers/comisionAnualidad";

export interface ResumenClubStore
  extends GetAnualidadProyecto,
    GetAnualidadProyectosOptions {}

export const resumenClubStore: (state) => ResumenClubStore = state => {
  const comisionAnualidad: ComisionAnualidadState = state.comisionAnualidad;

  return {
    anualidadProyecto: comisionAnualidad.anualidadProyecto,
    gettingAnualidadProyecto: comisionAnualidad.gettingAnualidadProyecto,
    gettingAnualidadProyectoError:
      comisionAnualidad.gettingAnualidadProyectoError,

    anualidadProyectosOptions: comisionAnualidad.anualidadProyectosOptions,
    gettingAnualidadProyectosOptions:
      comisionAnualidad.gettingAnualidadProyectosOptions,
    gettingAnualidadProyectosOptionsError:
      comisionAnualidad.gettingAnualidadProyectosOptionsError
  };
};
